import React from "react";
import { Outlet } from "react-router-dom"; // Để render sub-routes
import MarketNavbar from "./MarketNavbar"; // Navbar con, tạo sau
import Footer from "../../../layout/Footer";

function MarketLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* // Navbar với links thanh lý, trang chủ, hoạt động */}
      <MarketNavbar />
      
      {/* // Nơi render sub-page (thanh lý, etc.) */}
      <main className="flex-1">
        <Outlet />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default MarketLayout;
